import { render, staticRenderFns } from "./SideBarArea.vue?vue&type=template&id=6fb03879&scoped=true"
import script from "./SideBarArea.vue?vue&type=script&lang=js"
export * from "./SideBarArea.vue?vue&type=script&lang=js"
import style0 from "./SideBarArea.vue?vue&type=style&index=0&id=6fb03879&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb03879",
  null
  
)

export default component.exports